import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantEditResidencePage = {
  alert: {
    error: 'applicant-edit-residence-page.alert.error',
  },
  footer: {
    root: 'applicant-edit-residence-page.footer.root',
  },
  form: {
    addressLine1Input:
      'applicant-edit-residence-page.form.address-line-1-input',
    addressLine1InputError:
      'applicant-edit-residence-page.form.address-line-1-input-error',
    addressLine2Input:
      'applicant-edit-residence-page.form.address-line-2-input',
    amountInput: 'applicant-edit-residence-page.form.amount-input',
    amountInputError: 'applicant-edit-residence-page.form.amount-input-error',
    cancelButton: 'applicant-edit-residence-page.form.cancel-button',
    cityInput: 'applicant-edit-residence-page.form.city-input',
    cityInputError: 'applicant-edit-residence-page.form.city-input-error',
    h1: 'applicant-edit-residence-page.form.h1',
    h2: 'applicant-edit-residence-page.form.h2',
    monthSelect: 'applicant-edit-residence-page.form.month-select',
    monthSelectError: 'applicant-edit-residence-page.form.month-select-error',
    previousAddressLine1Input:
      'applicant-edit-residence-page.form.previous-address-line-1-input',
    previousAddressLine1InputError:
      'applicant-edit-residence-page.form.previous-address-line-1-input-error',
    previousAddressLine2Input:
      'applicant-edit-residence-page.form.previous-address-line-2-input',
    previousCityInput: 'applicant-edit-residence-page.form.previous-city-input',
    previousCityInputError:
      'applicant-edit-residence-page.form.previous-city-input-error',
    previousResidenceRoot:
      'applicant-edit-residence-page.form.previous-residence-root',
    previousStateSelect:
      'applicant-edit-residence-page.form.previous-state-select',
    previousStateSelectError:
      'applicant-edit-residence-page.form.previous-state-select-error',
    previousZipCodeInput:
      'applicant-edit-residence-page.form.previous-zip-code-input',
    previousZipCodeInputError:
      'applicant-edit-residence-page.form.previous-zip-code-input-error',
    residenceTypeSelect:
      'applicant-edit-residence-page.form.residence-type-select',
    residenceTypeSelectError:
      'applicant-edit-residence-page.form.residence-type-select-error',
    root: 'applicant-edit-residence-page.form.root',
    stateSelect: 'applicant-edit-residence-page.form.state-select',
    stateSelectError: 'applicant-edit-residence-page.form.state-select-error',
    submitButton: 'applicant-edit-residence-page.form.submit-button',
    zipCodeInput: 'applicant-edit-residence-page.form.zip-code-input',
    zipCodeInputError:
      'applicant-edit-residence-page.form.zip-code-input-error',
  },
  header: {
    drawerButton: 'applicant-edit-residence-page.header.drawer-button',
    previousStepButton:
      'applicant-edit-residence-page.header.previous-step-button',
    root: 'applicant-edit-residence-page.header.root',
  },
  progress: {
    root: 'applicant-edit-residence-page.progress.root',
  },
} as const satisfies PageLocatorMap;
